var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import BaseApiClient from '@/plugins/apis/base-api-client';
var ALLOWED_IMAGE_MIME_TYPES = ['image/jpeg', 'image/png', 'image/gif', 'image/webp'];
var MAX_IMAGE_SIZE_BYTES = 10 * 1024 * 1024;
export function validateImageFile(file) {
    if (!ALLOWED_IMAGE_MIME_TYPES.includes(file.type)) {
        return file.name + " \u306F\u5BFE\u5FDC\u3057\u3066\u3044\u306A\u3044\u30D5\u30A1\u30A4\u30EB\u5F62\u5F0F\u3067\u3059\uFF08jpg/png/gif/webp \u306E\u307F\uFF09";
    }
    if (file.size > MAX_IMAGE_SIZE_BYTES) {
        return file.name + " \u306E\u30D5\u30A1\u30A4\u30EB\u30B5\u30A4\u30BA\u304C 10MB \u3092\u8D85\u3048\u3066\u3044\u307E\u3059";
    }
    return null;
}
var resourceName = 'content_comment';
var ContentCommentApi = /** @class */ (function (_super) {
    __extends(ContentCommentApi, _super);
    function ContentCommentApi() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    Object.defineProperty(ContentCommentApi.prototype, "basePath", {
        get: function () {
            var companyId = this.companyId;
            return "/companies/" + companyId + "/contents";
        },
        enumerable: false,
        configurable: true
    });
    ContentCommentApi.prototype.fetchComments = function (contentId) {
        var basePath = this.basePath;
        var url = basePath + "/" + contentId + "/content_comments";
        return this.client.get(url, {
            params: {
                limit: 500
            }
        });
    };
    ContentCommentApi.prototype.fetchReplies = function (_a) {
        var contentId = _a.contentId, commentId = _a.commentId;
        var basePath = this.basePath;
        var url = basePath + "/" + contentId + "/content_comments/" + commentId + "/replies";
        return this.client.get(url);
    };
    ContentCommentApi.prototype.createComment = function (_a) {
        var contentId = _a.contentId, text = _a.text, mentioned_uids = _a.mentioned_uids, pin = _a.pin, images = _a.images, parentId = _a.parentId;
        var basePath = this.basePath;
        var url = basePath + "/" + contentId + "/content_comments";
        if (images && images.length > 0) {
            var formData_1 = new FormData();
            formData_1.append('content_comment[body]', text.trim());
            mentioned_uids.forEach(function (uid) { return formData_1.append('content_comment[mentioned_uids][]', uid); });
            if (pin) {
                formData_1.append('content_comment[pin][coordinate_ratio_x]', String(pin.coordinate_ratio_x));
                formData_1.append('content_comment[pin][coordinate_ratio_y]', String(pin.coordinate_ratio_y));
                if (pin.page !== undefined) {
                    formData_1.append('content_comment[pin][page]', String(pin.page));
                }
            }
            images.forEach(function (image) { return formData_1.append('content_comment[images][]', image); });
            if (parentId) {
                formData_1.append('content_comment[parent_id]', parentId);
            }
            return this.requestActionWithNamedProperty({
                url: url,
                method: 'post',
                data: formData_1,
                actionName: 'POST',
                resourceName: resourceName
            });
        }
        return this.requestActionWithNamedProperty({
            url: url,
            method: 'post',
            data: {
                content_comment: __assign({ body: text.trim(), mentioned_uids: mentioned_uids,
                    pin: pin }, (parentId ? { parent_id: parentId } : {}))
            },
            actionName: 'POST',
            resourceName: resourceName
        });
    };
    ContentCommentApi.prototype.updatePin = function (_a) {
        var contentId = _a.contentId, commentId = _a.commentId, pin = _a.pin;
        var basePath = this.basePath;
        var url = basePath + "/" + contentId + "/content_comments/" + commentId;
        return this.requestActionWithNamedProperty({
            url: url,
            method: 'put',
            data: {
                content_comment: {
                    pin: pin
                }
            },
            actionName: 'UPDATE',
            resourceName: resourceName
        });
    };
    ContentCommentApi.prototype.deleteComment = function (_a) {
        var contentId = _a.contentId, commentId = _a.commentId;
        var basePath = this.basePath;
        var url = basePath + "/" + contentId + "/content_comments/" + commentId;
        return this.requestActionWithNamedProperty({
            url: url,
            method: 'delete',
            actionName: 'DELETE',
            resourceName: resourceName
        });
    };
    ContentCommentApi.prototype.updateComment = function (_a) {
        var commentId = _a.commentId, contentId = _a.contentId, text = _a.text, mentionedUids = _a.mentionedUids, images = _a.images, deleteImageIds = _a.deleteImageIds;
        var basePath = this.basePath;
        var url = basePath + "/" + contentId + "/content_comments/" + commentId;
        var hasImages = images && images.length > 0;
        var hasDeleteIds = deleteImageIds && deleteImageIds.length > 0;
        if (hasImages) {
            var formData_2 = new FormData();
            formData_2.append('content_comment[body]', text.trim());
            mentionedUids.forEach(function (uid) { return formData_2.append('content_comment[mentioned_uids][]', uid); });
            images.forEach(function (image) { return formData_2.append('content_comment[images][]', image); });
            if (hasDeleteIds) {
                deleteImageIds.forEach(function (id) { return formData_2.append('content_comment[delete_image_ids][]', id); });
            }
            return this.requestActionWithNamedProperty({
                url: url,
                method: 'put',
                actionName: 'UPDATE',
                resourceName: resourceName,
                data: formData_2
            });
        }
        return this.requestActionWithNamedProperty({
            url: url,
            method: 'put',
            actionName: 'UPDATE',
            resourceName: resourceName,
            data: {
                content_comment: __assign({ body: text.trim(), mentioned_uids: mentionedUids }, (hasDeleteIds ? { delete_image_ids: deleteImageIds } : {}))
            }
        });
    };
    ContentCommentApi.prototype.fetchMentionableUsers = function (_a) {
        var contentId = _a.contentId;
        var _b = this, basePath = _b.basePath, client = _b.client;
        return client.get(basePath + "/" + contentId + "/mentionable_users");
    };
    return ContentCommentApi;
}(BaseApiClient));
export default new ContentCommentApi();
